import { createContext, useState, useMemo } from 'react';

const HeaderContext = createContext({});

export function HeaderProvider({ children }) {
  const [header, setHeader] = useState([]);

  const value = useMemo(() => ({ header, setHeader }), [header]);

  return (
    <HeaderContext.Provider value={value}>{children}</HeaderContext.Provider>
  );
}

export default HeaderContext;
